// extracted by mini-css-extract-plugin
export default {"signals":"signals_signals__kNAjc"};